import { render, staticRenderFns } from "./FormProductComponent.vue?vue&type=template&id=218aab88"
import script from "./FormProductComponent.vue?vue&type=script&lang=js"
export * from "./FormProductComponent.vue?vue&type=script&lang=js"
import style0 from "./FormProductComponent.vue?vue&type=style&index=0&id=218aab88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports